import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Chat from './components/Chat';
import IdleTimeout from './components/IdleTimeout';
import { authAPI, hasSession } from './services/api';

function App() {
  const [authState, setAuthState] = useState(() => (hasSession() ? 'authenticated' : 'unknown'));

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        await authAPI.getCurrentUser();
        if (mounted) setAuthState('authenticated');
      } catch {
        if (mounted) setAuthState('unauthenticated');
      }
    })();
    return () => { mounted = false; };
  }, []);

  const PrivateRoute = ({ children }) => {
    if (authState === 'unknown') return null;
    return authState === 'authenticated' ? children : <Navigate to="/login" />;
  };

  return (
    <Router>
      {authState === 'authenticated' && <IdleTimeout />}
      <Routes>
        <Route path="/login" element={<Login onAuthenticated={() => setAuthState('authenticated')} />} />
        <Route
          path="/chat"
          element={
            <PrivateRoute>
              <Chat />
            </PrivateRoute>
          }
        />
        <Route
          path="/"
          element={
            <Navigate to={authState === 'authenticated' ? '/chat' : '/login'} />
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
